import { useRef, useState } from "react";

type ConversationTitleInputProps = {
  initial: string;
  onSave: (title: string) => void;
  onCancel: () => void;
  className?: string;
};

export default function ConversationTitleInput({
  initial,
  onSave,
  onCancel,
  className = "",
}: ConversationTitleInputProps) {
  const [value, setValue] = useState(initial);
  const settled = useRef(false);

  function finish(save: boolean) {
    if (settled.current) return;
    settled.current = true;
    const title = value.trim();
    if (save && title && title !== initial) onSave(title);
    else onCancel();
  }

  return (
    <input
      autoFocus
      value={value}
      maxLength={255}
      aria-label="Chat name"
      onChange={(e) => setValue(e.target.value)}
      onFocus={(e) => e.target.select()}
      onBlur={() => finish(true)}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          finish(true);
        } else if (e.key === "Escape") {
          e.preventDefault();
          e.stopPropagation();
          finish(false);
        }
      }}
      className={className}
    />
  );
}
